// src/redux/reducers/countryReducer.js
import { COUNTRY_ACTIONS as TYPES } from "../../actions/chatbotActions/chatbotActionTypes";

const initialState = {
  countries: [],
  country: null, // for fetch by id
  loading: false,
  error: null,
};

export const countryReducer = (state = initialState, action) => {
  switch (action.type) {
    // Requests
    case TYPES.FETCH_REQUEST:
    case TYPES.FETCH_BY_ID_REQUEST:
    case TYPES.ADD_REQUEST:
    case TYPES.UPDATE_REQUEST:
    case TYPES.DELETE_REQUEST:
      return { ...state, loading: true, error: null };

    // Success
    case TYPES.FETCH_SUCCESS:
      return { ...state, loading: false, countries: action.payload };

    case TYPES.FETCH_BY_ID_SUCCESS:
      return { ...state, loading: false, country: action.payload };

    case TYPES.ADD_SUCCESS:
      return { ...state, loading: false, countries: [...state.countries, action.payload] };

    case TYPES.UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        countries: action.payload
      };

    case TYPES.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        countries: state.countries.filter((c) => c.id !== action.payload),
      };

    // Failure
    case TYPES.FETCH_FAILURE:
    case TYPES.FETCH_BY_ID_FAILURE:
    case TYPES.ADD_FAILURE:
    case TYPES.UPDATE_FAILURE:
    case TYPES.DELETE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
